import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resetează scroll-ul ferestrei la (0, 0) la fiecare schimbare de rută.
 * Se montează o singură dată în interiorul <BrowserRouter> și acoperă toate paginile.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Folosim "auto" ca să fie instantaneu, fără animație (comportament de navigare clasic).
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
